import { ReactNode } from 'react';
import { ScrollView } from 'react-native';

import { styles } from './styles';

export const Container = ({ children }: { children: ReactNode }) => {
  return <ScrollView style={styles.container}>{children}</ScrollView>;
};
